import { render, staticRenderFns } from "./Image3D.vue?vue&type=template&id=a06256c0&scoped=true&"
import script from "./Image3D.vue?vue&type=script&lang=js&"
export * from "./Image3D.vue?vue&type=script&lang=js&"
import style0 from "./Image3D.vue?vue&type=style&index=0&id=a06256c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06256c0",
  null
  
)

export default component.exports